<div class="h-100 text-pre-line" #highlightContainer>{{value}}</div>
